export default __webpack_public_path__ + "static/media/footer-menu-02.63d1dca3.svg";